import { createHoverDrawPictogram } from './hover-draw-pictogram';

const PATHS = [
  'M16,31.36C7.53,31.36,0.64,24.47,0.64,16S7.53,0.64,16,0.64S31.36,7.53,31.36,16S24.47,31.36,16,31.36z M15.64,28h0.72v2.636c7.788-0.188,14.087-6.488,14.276-14.276H28v-0.72h2.636C30.447,7.853,24.147,1.553,16.36,1.364V4h-0.72V1.364\tC7.853,1.553,1.553,7.853,1.364,15.64H4v0.72H1.364c0.189,7.788,6.488,14.087,14.276,14.276V28z M22.748,20.312l-7.108-4.104V6h0.72\tv9.792l6.748,3.896L22.748,20.312z',
];

export const TimePictogram = createHoverDrawPictogram('TimePictogram', PATHS);
